import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "loading apollo"
}
const _hoisted_4 = { class: "dashboard-container" }
const _hoisted_5 = ["src"]

import { computed, ref } from "vue";
import dayjs, { Dayjs } from "dayjs";
import { useQuery } from "@vue/apollo-composable";
import { GET_ADMIN_GENERAL_MANAGER_DASHBOARD_URL } from "@/graphql/user/queries";
import MonthPicker from "@/components/MonthPicker.vue";
import { useI18n } from "vue-i18n";
import enUK from "@/locales/home/en-UK.json";

type MessageSchema = typeof enUK;


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminGeneralManager',
  setup(__props) {

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

// MONTH
const defaultMonth = dayjs(new Date());
const selectedMonth = ref<Dayjs | null>(defaultMonth);
const selectedMonthName = computed(
  () => selectedMonth?.value?.format("MMMM YYYY") ?? "",
);

const setPrevMonth = () => {
  selectedMonth.value = selectedMonth.value?.subtract(1, "M") ?? defaultMonth;
};

const setNextMonth = () => {
  selectedMonth.value = selectedMonth.value?.add(1, "M") ?? defaultMonth;
};

const month = computed(() => selectedMonth.value?.format("YYYY-MM-DD") ?? null);

const variables = computed(() => ({
  month: month.value,
}));

const { result, loading } = useQuery<{
  adminGeneralManagerDashboardUrl: string;
}>(GET_ADMIN_GENERAL_MANAGER_DASHBOARD_URL, variables);

const dashboardUrl = computed(
  () => result.value?.adminGeneralManagerDashboardUrl,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MonthPicker, {
        label: selectedMonthName.value,
        onPrev: setPrevMonth,
        onNext: setNextMonth
      }, null, 8, ["label"])
    ]),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("loading")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("iframe", {
        class: "metabase-dashboard",
        src: dashboardUrl.value
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})